const SMS_DIRECTORIES = {
  yonetim: [
    { name: 'Aad MURAT BAYSOY', phone: '0507 038 73 06' },
    { name: 'Aad Veysel Tekdağ', phone: '0532 407 06 25' },
    { name: 'Aad Yunus Esen', phone: '0532 525 31 62' },
    { name: 'Kasım VURALOĞLU', phone: '0533 604 85 08' },
    { name: 'Aad Sertac Bektaş', phone: '0532 063 47 94' },
    { name: 'Oya Abla', phone: '0505 312 80 97' },
    { name: 'AAD Fahrettin Esin', phone: '0505 484 10 50' },
    { name: 'eRBİL BAYSAL PATNOS 06 @04', phone: '0532 478 04 87' },
    { name: 'Kurban Yorulmaz', phone: '0544 587 22 69' },
    { name: 'Nurten Bulut', phone: '0555 184 64 16' },
    { name: 'Omer Kahraman', phone: '0539 590 97 77' },
    { name: 'Aad Seref', phone: '0553 766 57 21' },
    { name: 'Mehmet Polat', phone: '0531 880 26 92' },
    { name: 'Mehmet Abi Zirve İnşaat', phone: '0532 176 82 34' },
    { name: 'Ahmet Orhan', phone: '0546 878 04 00' },
    { name: 'Eyüp Demir', phone: '0534 730 13 95' },
    { name: 'ueuujeue96', phone: '0541 834 06 04' },
    { name: 'VEZİR', phone: '0552 615 04 04' },
    { name: 'Fuat Taşdelen', phone: '0536 953 04 06' },
    { name: 'Metin Ilhan', phone: '0542 812 88 72' },
  ],
  uyeler: []
}

export default SMS_DIRECTORIES
